import React from "react";
import { AlertTriangle, ShieldAlert, Pill } from "lucide-react";

const RISK_META = {
  risco_suicida:       { label: "Risco suicida", icon: ShieldAlert, cls: "ds-badge-danger" },
  alergia_medicamento: { label: "Alergia medicamentosa", icon: Pill, cls: "ds-badge-warning" },
  violencia:           { label: "Violência", icon: AlertTriangle, cls: "ds-badge-danger" },
  abuso_substancia:    { label: "Uso de substância", icon: AlertTriangle, cls: "ds-badge-warning" },
};

export default function RiskBadge({ flag }) {
  const meta = RISK_META[flag] || { label: flag, icon: AlertTriangle, cls: "ds-badge-neutral" };
  const Icon = meta.icon;
  return (
    <span className={`ds-badge ${meta.cls}`} data-testid={`risk-${flag}`}>
      <Icon className="w-3 h-3" />
      {meta.label}
    </span>
  );
}
